import { LANGUAGE } from "@/common/utils/constants.js";

export const GOP_VIEW_PAGE = {
	[LANGUAGE.en.short]: {
		edit: 'Edit',
		delete: 'Delete',
		cancel: 'Cancel',
		create: 'Create',
		archive: 'Archive',
		unarchive: 'Unarchive',
		translate: 'Translate',
		reportIssue: 'Report issue',
		suggestModification: 'Suggest modification',
		contributeToPage: 'Contribute to this page',
		addToHighlights: 'Add to highlights',
		removeFromHighlights: 'Remove from highlights',
		revenue: "Revenue",
		contact: 'Contact',
		copyLink: 'Copy link',
		addToFavorite: 'Add to favorites',
		removeFromFavorite: 'Remove from favorites',
		maturity: 'Maturity',
		maturityOptions: {
			EMPTY: 'Empty',
			READY_TO_DELIVER: 'Ready to deliver',
			READY_TO_SELL: 'Ready to sell'
		},
		fileTypes: {
			PDF: 'PDF',
			PPT: 'PPT'
		},
		download: 'Download',
		goBack: 'Go back',
		approve: 'Approve',
		more: 'show more',
		less: 'show less',
		officialPresentation: 'Official presentation',
		clientSuccessStoriesAndRelatedResources: 'Related Resources',
		links: 'Links',
		files: 'Files',
		file: 'File',
		downloadAll: "Download all",
		insights: 'Insights',
		salesInsights: 'Sales Insights',
		proofingData: "Profiling data",
		clientNeedsAndBenefits: 'Client needs & benefits',
		competitors: 'Competitors',
		analysts: 'Analysts',
		tools: 'Tools',
		certificates: 'Certificates',
		marketData: 'Market data',
		offerData: 'Offer data',
		recognitionData: 'Recognition data',
		additionalInfo: 'Additional information',
		targetPersona: 'Target persona',
		lifecycle: 'Lifecycle',
		link: 'LINK',
		videoClickOpen: '[VIDEO] click to open',
		partnerships: "Partnerships",
		recognitions: "Recognitions",
		noData: "No data is available for this section",
		noDataAvailable: "No data available",
		sendYourSuggestion: "Send Your Suggestion",
		goToMarket: 'Recognized expertise',
		expandAll: 'Expand all',
		industry: 'Industry',
		techPractice: 'Tech Practice',
		serviceLine: 'Type of Business',
		closeAll: 'Close all',
		areYouSureDelete: `Are you sure you want to delete this {item}?`,
		cannotBeRestored: `Once the {item} is deleted, it cannot be restored.`,
		offer: "Offer",
		sector: 'Sector Presentation',
		successDeletedSector: 'Successfully deleted sector presentation',
		deliveryLocations: 'Delivery locations',
		category: {
			CORPORATE: 'Corporate Presentation',
			INDUSTRY: 'Industry Presentation',
			TECH_PRACTICE: 'Tech Practice Presentation',
			PARTNERSHIP: 'Partnership Presentation',
			NA: '',
			OFFER: 'Offer Presentation',
			RECOGNITION: 'Recognition Presentation',
			COUNTRY: 'Country Presentation'
		},
		regions: {
			"EUROPE": 'Europe',
			"NORTH_AMERICA": 'North America',
			"APAC": 'APAC',
			"MIDDLE_EAST_AFRICA": 'Middle East & Africa',
			"NA": "N/A",
			"GLOBAL": "Global"
		},
		regionsTitle: 'Regions',
		recognition: 'Recognition',
		additionalLinks: "Additional links",
		countries: 'Countries',
		mainOffice: 'Main Office Locations & Employee Capacity',
		relatedToThisRecognition: "Related to this recognition",
		offers: "Offers",
		sectors: "Sector Presentations",
		successStories: "Success Stories",
		positionInAkkodisGTM: "Fit into Akkodis' Go-to-Market Strategy",
		countryExpertise: "Country Expertise",
		expertise: "Expertise",
	},
	[LANGUAGE.de.short]: {
		edit: 'Bearbeiten',
		delete: 'Löschen',
		cancel: 'Abbrechen',
		create: 'Erstellen',
		archive: 'Archivieren',
		unarchive: 'Archivierung aufheben',
		translate: 'Übersetzen',
		reportIssue: 'Problem melden',
		suggestModification: 'Änderung vorschlagen',
		contributeToPage: 'Zu dieser Seite beitragen',
		addToHighlights: 'Zu Highlights hinzufügen',
		removeFromHighlights: 'Aus Highlights entfernen',
		revenue: "Einnahmen",
		contact: 'Kontakt',
		copyLink: 'Link kopieren',
		addToFavorite: 'Zu Favoriten hinzufügen',
		removeFromFavorite: 'Aus Favoriten entfernen',
		maturity: 'Reifegrad',
		maturityOptions: {
			EMPTY: 'Leer',
			READY_TO_DELIVER: 'Versandbereit',
			READY_TO_SELL: 'Verkaufsbereit'
		},
		fileTypes: {
			PDF: 'PDF',
			PPT: 'PPT'
		},
		download: 'Herunterladen',
		goBack: 'Zurück',
		approve: 'Genehmigen',
		more: "Mehr anzeigen",
		less: "Weniger anzeigen",
		officialPresentation: 'Offizielle Präsentation',
		clientSuccessStoriesAndRelatedResources: 'Passende Ressourcen',
		links: 'Links',
		files: 'Dateien',
		file: "Datei",
		downloadAll: "Alle herunterladen",
		insights: 'Analysen',
		salesInsights: "Vertriebserkenntnisse",
		proofingData: "Profiling-Daten",
		clientNeedsAndBenefits: "Kundenbedürfnisse & Vorteile",
		competitors: "Mitbewerber",
		analysts: "Analysten",
		tools: "Tools",
		certificates: "Zertifikate",
		marketData: "Marktdaten",
		offerData: "Angebotsdaten",
		recognitionData: "Anerkennungsdaten",
		additionalInfo: "Zusätzliche Informationen",
		targetPersona: "Target Persona",
		lifecycle: "Lebenszyklus",
		link: "LINK",
		videoClickOpen: "[VIDEO] Zum Öffnen klicken",
		partnerships: "Partnerschaften",
		recognitions: "Anerkennungen",
		noData: "Für diesen Bereich sind keine Daten verfügbar",
		noDataAvailable: "Keine Daten verfügbar",
		sendYourSuggestion: "Senden Sie Ihren Vorschlag",
		goToMarket: 'Anerkannte Expertise',
		expandAll: "Alle aufklappen",
		industry: "Branche",
		techPractice: "Tech Practice",
		serviceLine: "Geschäftsbereich",
		closeAll: "Alle zuklappen",
		areYouSureDelete: `Möchten Sie dieses {item} wirklich löschen?`,
		cannotBeRestored: `Sobald das {item} gelöscht wurde, kann es nicht wiederhergestellt werden`,
		offer: "Angebot",
		sector: "Sektorenpräsentation",
		successDeletedSector: "Sektorenpräsentation erfolgreich gelöscht",
		deliveryLocations: "Bereitstellungsorte",
		category: {
			CORPORATE: "Unternehmenspräsentation",
			INDUSTRY: "Branchenpräsentation",
			TECH_PRACTICE: "Tech-Practice-Präsentation",
			PARTNERSHIP: "Partnerschaftspräsentation",
			NA: '',
			OFFER: "Angebotspräsentation",
			RECOGNITION: "Anerkennungspräsentation",
			COUNTRY: "Länderpräsentation"
		},
		regions: {
			EUROPE: "Europa",
			NORTH_AMERICA: "Nordamerika",
			APAC: "APAC",
			MIDDLE_EAST_AFRICA: "Naher Osten & Afrika",
			NA: "N/A",
			GLOBAL: "Global"
		},
		regionsTitle: "Regionen",
		recognition: "Anerkennung",
		additionalLinks: "Zusätzliche Links",
		countries: "Länder",
		mainOffice: "Hauptstandorte & Mitarbeiterkapazität",
		relatedToThisRecognition: "Im Zusammenhang mit dieser Anerkennung",
		offers: "Angebote",
		sectors: "Sektorenpräsentationen",
		successStories: "Erfolgsgeschichten",
		positionInAkkodisGTM: "Fit in Akkodis' Go-to-Market-Strategie",
		countryExpertise: "Länderspezifische Expertise",
		expertise: "Expertise"
	},
	[LANGUAGE.fr.short]: {
		edit: 'Modifier',
		delete: 'Supprimer',
		cancel: 'Annuler',
		create: 'Créer',
		archive: 'Archiver',
		unarchive: 'Non archivable',
		translate: 'Traduire',
		reportIssue: 'Signaler un problème',
		suggestModification: 'Suggérer une modification',
		contributeToPage: 'Contribuer à cette page',
		addToHighlights: 'Ajouter aux points forts',
		removeFromHighlights: 'Retirer des points forts',
		revenue: "Revenu",
		contact: 'Contact',
		copyLink: 'Copier le lien',
		addToFavorite: 'Ajouter aux favoris',
		removeFromFavorite: 'Retirer des favoris',
		maturity: 'Maturité',
		maturityOptions: {
			EMPTY: 'Vide',
			READY_TO_DELIVER: 'Prêt à livrer',
			READY_TO_SELL: 'Prêt à la vente'
		},
		fileTypes: {
			PDF: 'PDF',
			PPT: 'PPT'
		},
		download: 'Télécharger',
		goBack: 'Retourner',
		approve: 'Approuver',
		more: "Voir plus",
		less: "Voir moins",
		officialPresentation: 'Présentation officielle',
		clientSuccessStoriesAndRelatedResources: 'Ressources associées',
		links: 'Liens',
		files: 'Fichiers',
		file: "Fichier",
		downloadAll: "Tout télécharger",
		insights: 'Analyses',
		salesInsights: "Perspectives de vente",
		proofingData: "Données de profilage",
		clientNeedsAndBenefits: "Besoins et avantages du client",
		competitors: "Concurrents",
		analysts: "Analystes",
		tools: "Outils",
		certificates: "Certificats",
		marketData: "Données de marché",
		offerData: "Données de l'offre",
		recognitionData: "Données de reconnaissance",
		additionalInfo: "Informations complémentaires",
		targetPersona: "Target persona",
		lifecycle: "Cycle de vie",
		link: "LIEN",
		videoClickOpen: "[VIDÉO] Cliquer pour ouvrir",
		partnerships: "Partenariats",
		recognitions: "Distinctions",
		noData: "Aucune donnée n'est disponible pour cette section",
		noDataAvailable: "Aucune donnée disponible",
		sendYourSuggestion: "Envoyez votre suggestion",
		goToMarket: "Expertise reconnue",
		expandAll: "Tout développer",
		industry: "Secteur d'activité",
		techPractice: "Pratique technologique",
		serviceLine: "Type d'activité",
		closeAll: "Tout réduire",
		areYouSureDelete: `Êtes-vous sûr de vouloir effectuer cette suppression ?`,
		cannotBeRestored: `Une fois l'élément supprimé, il ne pourra être restauré.`,
		offer: "Offre",
		sector: "Présentation du secteur",
		successDeletedSector: "Présentation du secteur supprimée avec succès",
		deliveryLocations: "Lieux de prestation",
		category: {
			CORPORATE: "Présentation de l'entreprise",
			INDUSTRY: "Présentation du secteur",
			TECH_PRACTICE: "Présentation на Pratique technologique",
			PARTNERSHIP: "Présentation du partenariat",
			NA: '',
			OFFER: "Présentation de l'offre",
			RECOGNITION: "Présentation de la reconnaissance",
			COUNTRY: "Présentation du pays"
		},
		regions: {
			EUROPE: "Europe",
			NORTH_AMERICA: "Amérique du Nord",
			APAC: "APAC",
			MIDDLE_EAST_AFRICA: "Moyen-Orient et Afrique",
			NA: "N/A",
			GLOBAL: "Global"
		},
		regionsTitle: "Régions",
		recognition: "Reconnaissance",
		additionalLinks: "Liens supplémentaires",
		countries: "Pays",
		mainOffice: "Bureaux principaux et capacité d'employés",
		relatedToThisRecognition: "Im Zusammenhang mit dieser Anerkennung",
		offers: "Angebote",
		sectors: "Sektorenpräsentationen",
		successStories: "Erfolgsgeschichten",
		positionInAkkodisGTM: "Fit in Akkodis' Go-to-Market-Strategie",
		countryExpertise: "Länderspezifische Expertise",
		expertise: "Expertise"
	},
	[LANGUAGE.it.short]: {
		edit: 'Modifica',
		delete: 'Elimina',
		cancel: 'Annulla',
		create: 'Crea',
		archive: 'Archivio',
		unarchive: 'Annulla l\'archiviazione',
		translate: 'Tradurre',
		reportIssue: 'Segnala un problema',
		suggestModification: 'Suggerisci una modifica',
		contributeToPage: 'Contribuisci a questa pagina',
		addToHighlights: 'Aggiungi ai messaggi in evidenza',
		removeFromHighlights: 'Rimuovi dai messaggi in evidenza',
		revenue: "Fatturato",
		contact: 'Contatti',
		copyLink: 'Copia link',
		addToFavorite: 'Aggiungi ai preferiti',
		removeFromFavorite: 'Rimuovi dai preferiti',
		maturity: 'Maturità',
		maturityOptions: {
			EMPTY: 'Vuoto',
			READY_TO_DELIVER: 'Pronto per la consegna',
			READY_TO_SELL: 'Pronto per la vendita'
		},
		fileTypes: {
			PDF: 'PDF',
			PPT: 'PPT'
		},
		download: 'Scaricamento',
		goBack: 'Indietro',
		approve: 'Approva',
		more: "Mostra altro",
		less: "Mostra meno",
		officialPresentation: 'Presentazione ufficiale',
		clientSuccessStoriesAndRelatedResources: 'Risorse correlate',
		links: 'Link',
		files: 'File',
		file: "File",
		downloadAll: "Scarica tutto",
		insights: 'Analisi',
		salesInsights: "Approfondimenti di vendita",
		proofingData: "Dati di profilazione",
		clientNeedsAndBenefits: "Esigenze e vantaggi del cliente",
		competitors: "Concorrenti",
		analysts: "Analisti",
		tools: "Strumenti",
		certificates: "Certificati",
		marketData: "Dati di mercato",
		offerData: "Dati dell'offerta",
		recognitionData: "Dati di riconoscimento",
		additionalInfo: "Informazioni aggiuntive",
		targetPersona: "Target persona",
		lifecycle: "Ciclo di vita",
		link: "LINK",
		videoClickOpen: "[VIDEO] Clicca per aprire",
		partnerships: "Partnership",
		recognitions: "Riconoscimenti",
		noData: "Nessun dato disponibile per questa sezione",
		noDataAvailable: "Nessun dato disponibile",
		sendYourSuggestion: "Invia il tuo suggerimento",
		goToMarket: "Competenza riconosciuta",
		expandAll: "Espandi tutto",
		industry: "Settore",
		techPractice: "Pratica tecnologica",
		serviceLine: "Linea di business",
		closeAll: "Comprimi tutto",
		areYouSureDelete: `Sei sicuro di voler eliminare questo {item}?`,
		cannotBeRestored: `Una volta eliminato, l'elemento {item} non potrà più essere ripristinato.`,
		offer: "Offerta",
		sector: "Presentazione del settore",
		successDeletedSector: "Presentazione del settore eliminata con successo",
		deliveryLocations: "Sedi di erogazione",
		category: {
			CORPORATE: "Presentazione aziendale",
			INDUSTRY: "Presentazione del settore",
			TECH_PRACTICE: "Presentazione della Pratica tecnologica",
			PARTNERSHIP: "Presentazione della partnership",
			NA: '',
			OFFER: "Presentazione dell'offerta",
			RECOGNITION: "Presentazione del riconoscimento",
			COUNTRY: "Presentazione del paese"
		},
		regions: {
			EUROPE: "Europa",
			NORTH_AMERICA: "Nord America",
			APAC: "APAC",
			MIDDLE_EAST_AFRICA: "Medio Oriente e Africa",
			NA: "N/D",
			GLOBAL: "Globale"
		},
		regionsTitle: "Regioni",
		recognition: "Riconoscimento",
		additionalLinks: "Link aggiuntivi",
		countries: "Paesi",
		mainOffice: "Sedi centrali e capacità dei dipendenti",
		relatedToThisRecognition: "In relazione a questo riconoscimento",
		offers: "Offerte",
		sectors: "Presentazioni del settore",
		successStories: "Storie di successo",
		positionInAkkodisGTM: "Posizione nella strategia Go-to-Market di Akkodis",
		countryExpertise: "Competenza specifica del paese",
		expertise: "Competenza"
	},
	[LANGUAGE.ja.short]: {
		edit: '編集',
		delete: '削除',
		cancel: 'キャンセル',
		create: '作成',
		archive: 'アーカイブ',
		unarchive: 'アーカイブを解除する',
		translate: '翻訳',
		reportIssue: '問題を報告',
		suggestModification: '変更を提案',
		contributeToPage: 'このページに貢献する',
		addToHighlights: 'ハイライトに追加',
		removeFromHighlights: 'ハイライトから削除',
		revenue: "収益",
		contact: '連絡先',
		copyLink: 'リンクをコピー',
		addToFavorite: 'お気に入りに追加',
		removeFromFavorite: 'お気に入りから削除',
		maturity: '成熟度',
		maturityOptions: {
			EMPTY: '空',
			READY_TO_DELIVER: '配送可能',
			READY_TO_SELL: '販売可能'
		},
		fileTypes: {
			PDF: 'PDF',
			PPT: 'PPT'
		},
		download: 'ダウンロード',
		goBack: '戻る',
		approve: '承認',
		more: "展開する",
		less: "折りたたむ",
		officialPresentation: '公式プレゼンテーション',
		clientSuccessStoriesAndRelatedResources: '関連資料',
		links: 'リンク',
		files: 'ファイル',
		file: "ファイル",
		downloadAll: "すべてダウンロード",
		insights: 'インサイト',
		salesInsights: "営業インサイト",
		proofingData: "プロファイリングデータ",
		clientNeedsAndBenefits: "顧客のニーズとメリット",
		competitors: "競合他社",
		analysts: "アナリスト",
		tools: "ツール",
		certificates: "証明書",
		marketData: "市場データ",
		offerData: "提供データ",
		recognitionData: "表彰データ",
		additionalInfo: "追加情報",
		targetPersona: "ターゲットペルソナ",
		lifecycle: "ライフサイクル",
		link: "リンク",
		videoClickOpen: "[動画] クリックして開く",
		partnerships: "パートナーシップ",
		recognitions: "表彰・実績",
		noData: "このセクションのデータはありません",
		noDataAvailable: "データがありません",
		sendYourSuggestion: "提案を送信する",
		goToMarket: "認められた専門知識",
		expandAll: "すべて展開",
		industry: "業界",
		techPractice: "テックプラクティス",
		serviceLine: "事業区分",
		closeAll: "すべて折りたたむ",
		areYouSureDelete: `この{item}を削除してもよろしいですか?`,
		cannotBeRestored: `{item} を削除すると、復元することはできません。`,
		offer: "オファー",
		sector: "セクタープレゼンテーション",
		successDeletedSector: "セクタープレゼンテーションが正常に削除されました",
		deliveryLocations: "デリバリー拠点",
		category: {
			CORPORATE: "企業プレゼンテーション",
			INDUSTRY: "業界プレゼンテーション",
			TECH_PRACTICE: "テックプラクティスプレゼンテーション",
			PARTNERSHIP: "パートナーシッププレゼンテーション",
			NA: '',
			OFFER: "提供プレゼンテーション",
			RECOGNITION: "表彰プレゼンテーション",
			COUNTRY: "国別プレゼンテーション"
		},
		regions: {
			EUROPE: "欧州",
			NORTH_AMERICA: "北米",
			APAC: "APAC",
			MIDDLE_EAST_AFRICA: "中東・アフリカ",
			NA: "該当なし",
			GLOBAL: "グローバル"
		},
		regionsTitle: "地域",
		recognition: "表彰",
		additionalLinks: "追加リンク",
		countries: "国",
		mainOffice: "主要オフィス拠点と言い換え・従業員数収容能力",
		relatedToThisRecognition: "この表彰に関連する",
		offers: "オファー",
		sectors: "セクタープレゼンテーション",
		successStories: "成功事例",
		positionInAkkodisGTM: "AkkodisのGo-to-Market戦略における位置付け",
		countryExpertise: "国別専門知識",
		expertise: "専門知識"
	},
	[LANGUAGE.es.short]: {
		edit: 'Editar',
		delete: 'Eliminar',
		cancel: 'Cancelar',
		create: 'Crear',
		archive: 'Archivar',
		unarchive: 'Desarchivar',
		translate: 'Traducir',
		reportIssue: 'Informar de un error',
		suggestModification: 'Sugerir una modificación',
		contributeToPage: 'Contribuir a esta página',
		addToHighlights: 'Añadir a destacados',
		removeFromHighlights: 'Quitar de destacados',
		revenue: "Ingresos",
		contact: 'Contacto',
		copyLink: 'Copiar enlace',
		addToFavorite: 'Añadir a favoritos',
		removeFromFavorite: 'Quitar de favoritos',
		maturity: 'Madurez',
		maturityOptions: {
			EMPTY: 'Vacío',
			READY_TO_DELIVER: 'Listo para entregar',
			READY_TO_SELL: 'Listo para vender'
		},
		fileTypes: {
			PDF: 'PDF',
			PPT: 'PPT'
		},
		download: 'Descargar',
		goBack: 'Volver',
		approve: 'Aprobar',
		more: "Mostrar más",
		less: "Mostrar menos",
		officialPresentation: 'Presentación oficial',
		clientSuccessStoriesAndRelatedResources: 'Recursos relacionados',
		links: 'Enlaces',
		files: 'Archivos',
		file: "Archivo",
		downloadAll: "Descargar todo",
		insights: 'Estadísticas',
		salesInsights: "Perspectivas de ventas",
		proofingData: "Datos de perfilado",
		clientNeedsAndBenefits: "Necesidades y beneficios del cliente",
		competitors: "Competidores",
		analysts: "Analistas",
		tools: "Herramientas",
		certificates: "Certificados",
		marketData: "Datos de mercado",
		offerData: "Datos de la oferta",
		recognitionData: "Datos de reconocimiento",
		additionalInfo: "Información adicional",
		targetPersona: "Target persona",
		lifecycle: "Ciclo de vida",
		link: "ENLACE",
		videoClickOpen: "[VÍDEO] Haz clic para abrir",
		partnerships: "Alianzas",
		recognitions: "Reconocimientos",
		noData: "No hay datos disponibles para esta sección",
		noDataAvailable: "No hay datos disponibles",
		sendYourSuggestion: "Envía tu sugerencia",
		goToMarket: "Experiencia reconocida",
		expandAll: "Expandir todo",
		industry: "Industria",
		techPractice: "Práctica tecnológica",
		serviceLine: "Línea de negocio",
		closeAll: "Contraer todo",
		areYouSureDelete: `¿Estás seguro de que deseas eliminar este {elemento}?`,
		cannotBeRestored: `Una vez eliminado el {elemento}, no se puede recuperar.`,
		offer: "Oferta",
		sector: "Presentación del sector",
		successDeletedSector: "Presentación del sector eliminada con éxito",
		deliveryLocations: "Lugares de prestación",
		category: {
			CORPORATE: "Presentación corporativa",
			INDUSTRY: "Presentación del sector",
			TECH_PRACTICE: "Presentación de la Práctica tecnológica",
			PARTNERSHIP: "Presentación de la alianza",
			NA: '',
			OFFER: "Presentación de la oferta",
			RECOGNITION: "Presentación del reconocimiento",
			COUNTRY: "Presentación del país"
		},
		regions: {
			EUROPE: "Europa",
			NORTH_AMERICA: "Norteamérica",
			APAC: "APAC",
			MIDDLE_EAST_AFRICA: "Oriente Medio y África",
			NA: "N/D",
			GLOBAL: "Global"
		},
		regionsTitle: "Regiones",
		recognition: "Reconocimiento",
		additionalLinks: "Enlaces adicionales",
		countries: "Países",
		mainOffice: "Oficinas principales y capacidad de empleados",
		relatedToThisRecognition: "En relación con este reconocimiento",
		offers: "Ofertas",
		sectors: "Presentaciones del sector",
		successStories: "Historias de éxito",
		positionInAkkodisGTM: "Posición en la estrategia Go-to-Market de Akkodis",
		countryExpertise: "Experiencia específica del país",
		expertise: "Experiencia"
	}
}
